module.exports = __webpack_public_path__ + "img/app3.ffeb0f1d.png";